import React from 'react'
import { whatsapp } from '../../assets'
import {ImageBuffer} from '../'

import './customerSupport.css'

const CustomerSupport = () => {
    const whatsappNumber = "14693262931";
    const whatsappMessage = encodeURIComponent(
        "From Gloria's Serenity Homes Health, i want need to make an enquiry on..."
    );
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
        <div className='customer-support-wrapper'>
            <small>Contact us</small>

            <a
                href={`${whatsappLink}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span>
                    <ImageBuffer src={whatsapp} alt='contact us' />
                </span>
            </a>
            
        </div>
    </>
  )
}

export default CustomerSupport